export default __webpack_public_path__ + "static/media/shoes_sneaker.b4323a7e.jpg";